exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#transparentImageDemo{color:#fff}#transparentImageDemo canvas{border:1px solid #fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./app/styles/transparentImageDemo.scss
// module id = 18
// module chunks = 0